import Parchment from 'parchment.js';
import Block, { BlockEmbed } from './block.js';


class Container extends Parchment.Container { }
Container.allowedChildren = [Block, BlockEmbed, Container];


export default Container;



// WEBPACK FOOTER //
// ./blots/container.js